<style>
#AddGroup .v--modal-box.v--modal {
  min-height: 200px !important;
  min-width: 500px !important;
}
#AddGroup .v-input__slot,
#AddGroup .v-text-field__slot label {
  font-size: 12px;
}
</style>

<template>
  <Modal modalName="AddGroup" title="Dodawanie grupy" @saved="save" :buttons="['save']">
    <div class="wrapper">
      <v-layout>
        <v-flex xs12>
          <div class="input__wrapper">
            <v-text-field
              v-model="groupname"
              id="groupname"
              :rules="[rules.required]"
              label="Nazwa nowej grupy"
            ></v-text-field>
          </div>
        </v-flex>
      </v-layout>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    groupname: undefined,
    rules: {
      required: value => !!value || "Pole wymagane"
    }
  }),
  computed: {},
  methods: {
    save() {
      if (!this.groupname) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Uzupełnij wszystkie wymagane pola"
        );
        return;
      }
      const self = this;
      let payload = {
        gname: this.groupname
      };
      this.$store.dispatch("addGroup", payload).then(success => {
        if (success) {
          this.$root.$emit("newGroupAdded");
          this.$modal.hide("AddGroup");
          this.$root.$emit("showSnackbar", "success", "Poprawnie dodano grupę");
          this.groupname = undefined;
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Błąd podczas dodawania grupy"
          );
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/settings/modals/userManagement/AddGroup.vue